/**
 * Quill + KaTeX bootstrap.
 *
 * Quill's built-in formula module requires a global `window.katex` before the
 * editor is instantiated. Importing this module once (at the top of the first
 * file that renders a ReactQuill editor) wires up KaTeX and registers the
 * mhchem extension so chemical equations like `\ce{H2SO4}` render correctly.
 *
 * Usage:
 *   import '../../utils/quillSetup';
 *   import ReactQuill from 'react-quill';
 *   import 'react-quill/dist/quill.snow.css';
 */
import katex from 'katex';
import 'katex/dist/katex.min.css';
// Registers the mhchem extension on the imported KaTeX instance.
import 'katex/contrib/mhchem';

if (typeof window !== 'undefined' && !window.katex) {
  window.katex = katex;
}

export default katex;
